import { render, staticRenderFns } from "./HeadersDataTableSettings.vue?vue&type=template&id=15d8c109&scoped=true"
import script from "./HeadersDataTableSettings.vue?vue&type=script&lang=js"
export * from "./HeadersDataTableSettings.vue?vue&type=script&lang=js"
import style0 from "./HeadersDataTableSettings.vue?vue&type=style&index=0&id=15d8c109&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d8c109",
  null
  
)

export default component.exports